<template>
  <div>
    <PopupPage :subtitle1="3" />
    <div>
      <breadcrumb :breadcrumb_link="restaurant_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">RESTAURANT</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container contentDesc">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <div class="title1">
            <h2>
              <strong>{{ $t('resta_title') }}</strong>
            </h2>
          </div>
          <div class="title2">
            <h4>{{ $t('resta_subtitle1') }}</h4>
          </div>
          <div class="title3">
            <p v-html="$t('resta_subtitle2')"></p>
          </div>
        </div>
      </div>
    </div>

    <GallerySlideCarousels :slides="slides" :slide-count="4" :thumb-slide-width="60" />

    <div class="container mt-5 mb-5">
      <div class="container" v-show="isLang === 0">
        <div class="row d-flex justify-content-center mt-5 mb-5">
          <h1>SIGNATURE MENU</h1>
        </div>
        <div class="row d-flex justify-content-center">
          <!--          <Dining :show-signature-mode="true" />-->
          <!-- 시그니처메뉴 static으로 수정-->
          <div class="row d-flex justify-content-center">
            <div class="card-deck">
              <div class="card">
                <img
                  class="card-img-top"
                  src="@/assets/images/biotopia/restaurant_card_image06.jpg"
                  alt="Card image cap"
                  style="padding: 10px"
                />
                <div class="card-body">
                  <h5 class="card-title">바당 몽돌코스</h5>
                  <p class="sig-card-text card-text">
                    편안하고 조용한 공간에서 신선한 해산물을 주재료로 한 특선요리를 즐길수 있는 회코스
                  </p>
                </div>
              </div>
              <div class="card">
                <img
                  class="card-img-top"
                  src="@/assets/images/biotopia/restaurant_card_image05.jpg"
                  alt="Card image cap"
                  style="padding: 10px"
                />
                <div class="card-body">
                  <h5 class="card-title">제주한상</h5>
                  <p class="text-narrow card-text">
                    제주의 로컬푸드를 담아낸 계절별 신선한 회와 제주 전통 식재료로 요리한 별미를 다채롭게 즐길수 있는
                    코스
                  </p>
                </div>
              </div>
              <div class="card">
                <img
                  class="card-img-top"
                  src="@/assets/images/biotopia/restaurant_card_image07.png"
                  alt="Card image cap"
                  style="padding: 10px"
                />
                <div class="card-body">
                  <h5 class="card-title">마다이반상</h5>
                  <p class="card-text">신선한 도미를 이용한 한상 요리로 비오토피아 레스토랑 중식 전용 메뉴</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <table class="web table table-borderless mt-5">
            <tbody>
              <tr style="border-bottom: 1px dashed #cdcdcd">
                <td>{{ $t('resta_table_td1') }}</td>
                <td colspan="4">{{ $t('resta_table_td2') }}</td>
              </tr>
              <tr>
                <td rowspan="2" style="border-bottom: 1px dashed #cdcdcd">{{ $t('resta_table_td3') }}</td>
                <td
                  style="border-bottom: 1px solid #cdcdcd; border-right: 1px solid #cdcdcd; background-color: #f9f9f9"
                >
                  {{ $t('resta_table_td4') }}
                </td>
                <td style="border-bottom: 1px solid #acacac; border-right: 1px solid #acacac">
                  12:00 - 16:00<br />{{ $t('resta_table_td12') }}
                </td>
                <td style="border-bottom: 1px solid #acacac; border-right: 1px solid #acacac">Last Order 15:00</td>
                <td style="border-bottom: 1px solid #acacac">
                  <a href="/files/pdf/Biotopia_restaurant_menu_lunch.pdf" target="_blank" class="res-button">{{
                    $t('resta_table_td6')
                  }}</a>
                </td>
              </tr>
              <tr>
                <td
                  style="border-right: 1px solid #acacac; border-bottom: 1px dashed #acacac; background-color: #f5f5f5"
                >
                  {{ $t('resta_table_td5') }}
                </td>
                <td style="border-right: 1px solid #acacac; border-bottom: 1px dashed #acacac">18:00 - 21:50</td>
                <td style="border-right: 1px solid #acacac; border-bottom: 1px dashed #acacac">Last Order 21:00</td>
                <td style="border-bottom: 1px dashed #acacac">
                  <a href="/files/pdf/Biotopia_restaurant_menu_dinner.pdf" target="_blank" class="res-button">{{
                    $t('resta_table_td7')
                  }}</a>
                </td>
              </tr>
              <tr style="border-bottom: 1px dashed #acacac">
                <td>{{ $t('resta_table_td13') }}</td>
                <td class="rowText" v-html="$t('resta_table_td14')"></td>
              </tr>
              <tr style="border-bottom: 1px dashed #acacac">
                <td>{{ $t('resta_table_td8') }}</td>
                <td class="rowText">{{ $t('resta_table_td9') }}</td>
              </tr>
              <tr style="border-bottom: 1px dashed #cdcdcd">
                <td>{{ $t('resta_table_td10') }}</td>
                <td class="rowText">{{ $t('resta_table_td11') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-borderless">
            <tbody>
              <tr style="border-bottom: 1px dashed #cdcdcd; border-top: 1px dashed #acacac">
                <td>{{ $t('resta_table_td1') }}</td>
                <td colspan="3">{{ $t('resta_table_td2') }}</td>
              </tr>
              <tr align="center">
                <td colspan="3" style="border-bottom: 1px dashed #acacac">{{ $t('resta_table_td3') }}</td>
              </tr>
              <tr>
                <td
                  style="border-bottom: 1px solid #acacac; border-right: 1px solid #acacac; background-color: #f5f5f5"
                >
                  {{ $t('resta_table_td4') }}
                </td>
                <td style="border-bottom: 1px solid #acacac; border-right: 1px solid #acacac">
                  12:00 - 16:00<br />{{ $t('resta_table_td12') }}
                </td>
                <td style="border-bottom: 1px solid #acacac">Last Order 15:00</td>
              </tr>
              <tr>
                <td colspan="3" style="border-bottom: 1px dashed #acacac" align="center">
                  <a href="/files/pdf/Biotopia_restaurant_menu_lunch.pdf" target="_blank" class="res-button">{{
                    $t('resta_table_td6')
                  }}</a>
                </td>
              </tr>
              <tr>
                <td
                  style="border-right: 1px solid #acacac; border-bottom: 1px dashed #acacac; background-color: #f5f5f5"
                >
                  {{ $t('resta_table_td5') }}
                </td>
                <td style="border-right: 1px solid #acacac; border-bottom: 1px dashed #acacac">18:00 - 21:50</td>
                <td style="border-bottom: 1px dashed #acacac">Last Order 21:00</td>
              </tr>
              <tr>
                <td colspan="3" style="border-bottom: 1px dashed #acacac" align="center">
                  <a href="/files/pdf/Biotopia_restaurant_menu_dinner.pdf" target="_blank" class="res-button">{{
                    $t('resta_table_td7')
                  }}</a>
                </td>
              </tr>
              <tr style="border-bottom: 1px dashed #acacac">
                <td>{{ $t('resta_table_td13') }}</td>
                <td colspan="2" class="rowText" v-html="$t('resta_table_td14')"></td>
              </tr>
              <tr style="border-bottom: 1px dashed #cdcdcd">
                <td>{{ $t('resta_table_td8') }}</td>
                <td colspan="2" class="rowText">{{ $t('resta_table_td9') }}</td>
              </tr>
              <tr style="border-bottom: 1px dashed #acacac">
                <td>{{ $t('resta_table_td10') }}</td>
                <td colspan="2" class="rowText">{{ $t('resta_table_td11') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!--    추천메뉴 & 프로모션 : 메뉴가 없으므로 일단 히든-->
    <div class="container" v-show="isLang === 0">
      <div class="dining">
        <div class="py-5 d-flex justify-content-center">
          <h1>추천메뉴 & 프로모션</h1>
        </div>
        <DiningPromotion />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import PopupPage from '@/pages/Popup/PopupPage.vue';
import DiningPromotion from '@/pages/MainPage/Components/DiningPromotion';

export default {
  name: 'Restaurant',
  data() {
    return {
      restaurant_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'RESTAURANT',
        present: this.$t('breadcrumb'),
      },
      slides: [
        {image: require('@/assets/images/biotopia/restaurant_bodyimage01.jpg')},
        {image: require('@/assets/images/biotopia/restaurant_bodyimage02.jpg')},
        {image: require('@/assets/images/biotopia/restaurant_bodyimage03.jpg')},
        {image: require('@/assets/images/biotopia/restaurant_bodyimage04.jpg')},
        {image: require('@/assets/images/biotopia/restaurant_bodyimage05.jpg')},
        {image: require('@/assets/images/biotopia/restaurant_bodyimage06.jpg')},
        {image: require('@/assets/images/biotopia/restaurant_bodyimage07.jpg')},
        {image: require('@/assets/images/biotopia/restaurant_bodyimage08.jpg')},
        {image: require('@/assets/images/biotopia/restaurant_bodyimage09.jpg')},
      ],
      isLang: 0,
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.restaurant_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'RESTAURANT',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  components: {
    Breadcrumb,
    GallerySlideCarousels,
    PopupPage,
    DiningPromotion,
  },
};
</script>

<style scoped lang="scss">
.jpword {
  word-break: break-all;
}
.anotherword {
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  td {
    word-break: keep-all;
  }
}
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.res-button {
  position: relative;
  display: inline-block;
  padding: 4px 22px;
  font-size: 15px;
  background-color: #524a3d;
  color: #fff;
  margin-right: 5px;
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/biotopia/restaurant_headerimage.jpg');
  }
  .web {
    td {
      vertical-align: middle;
    }
    .rowText {
      padding-left: 0px;
    }
  }
  .mobile {
    display: none;
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
  .dining {
    min-height: 10rem;
  }
  .web {
    display: none;
  }
  .mobile {
    td {
      vertical-align: middle;
    }
    .rowText {
      padding-left: 0px;
    }
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "레스토랑",
    "resta_title": "레스토랑",
    "resta_subtitle1": "프라이빗 공간에서 경험하는 특별한 다이닝",
    "resta_subtitle2": "세련되고 감각적인 인테리어와 뛰어난 자연 풍광을 가진 비오토피아 레스토랑에서는<br/>이탈리아 화덕에서 갓 구워낸 피자와 다채로운 양식, 한식 요리를 선보입니다.",
    "resta_table_td1": "위치",
    "resta_table_td2": "비오토피아 커뮤니티센터 1F",
    "resta_table_td3": "영업시간",
    "resta_table_td4": "중식",
    "resta_table_td5": "석식",
    "resta_table_td6": "메뉴보기",
    "resta_table_td7": "메뉴보기",
    "resta_table_td8": "좌석",
    "resta_table_td9": "총 60석",
    "resta_table_td10": "문의",
    "resta_table_td11": "064-793-6030",
    "resta_table_td12": "(※ 16:00-18:00 음료 주문가능)",
    "resta_table_td13": "휴장일",
    "resta_table_td14": "매주 월요일<br/>※ 상황에 따라 변동 될 수 있습니다."
  },

  "en":{
    "breadcrumb": "Restaurant",
    "resta_title": "Restaurant",
    "resta_subtitle1": "Special dining experience in a private space",
    "resta_subtitle2": "Restaurant BIOTOPIA offers pizzas freshly baked in Italian oven, various Western dishes and<br/>Korean dishes in an elegant and sensuous interior space and the exquisite view of natural scenery.",
    "resta_table_td1": "Location",
    "resta_table_td2": "Community center 1F",
    "resta_table_td3": "Opening Hours",
    "resta_table_td4": "Lunch",
    "resta_table_td5": "Dinner",
    "resta_table_td6": "Menu",
    "resta_table_td7": "Menu",
    "resta_table_td8": "Seat",
    "resta_table_td9": "60 seats in total",
    "resta_table_td10": "Inquiry",
    "resta_table_td11": "+82-64-793-6030",
    "resta_table_td12": "(※ Drinks available from 16:00 - 18:00)",
    "resta_table_td13": "Regular Closing Days",
    "resta_table_td14": "Closed on Mondays<br/>※ subject to change by hotel circumstances"
  },

  "ja": {
    "breadcrumb": "レストラン",
    "resta_title": "レストラン",
    "resta_subtitle1": "プライベートな空間で経験する特別なダイニング",
    "resta_subtitle2": "洗練された感覚的なインテリアと優れた自然の景色のビオトピアレストランでは<br/>イタリア式の釜で作った焼きたてのピザと多彩な洋食、韓国料理がお目見えします。",
    "resta_table_td1": "位置",
    "resta_table_td2": "コミュニティー・センター 1F",
    "resta_table_td3": "運営時間",
    "resta_table_td4": "中食",
    "resta_table_td5": "夕食",
    "resta_table_td6": "中食",
    "resta_table_td7": "夕食",
    "resta_table_td8": "規模",
    "resta_table_td9": "60席",
    "resta_table_td10": "お問い合わせ",
    "resta_table_td11": "+82-64-793-6030"
  }
}
</i18n>
